import React from 'react'

export default function Contact() {
    return (
        <div className="section">
            <div className="eyebrow">Contact</div>
            <h1 style={{fontSize:'2rem', fontWeight:900, letterSpacing:'-0.03em', color:'#0f172a'}}>Let's build something great.</h1>
            <p style={{color:'#64748b', marginTop:'6px', maxWidth:'620px'}}>Available for freelance, contract and full-time opportunities. Fast replies — usually within 24 hours.</p>

            <div className="contact-grid" style={{marginTop:'18px'}}>
                <div className="contact-card">
                    <h3>Get in touch</h3>
                    <p style={{color:'#64748b', fontSize:'0.92rem'}}>Prefer email or a quick call? Pick your channel.</p>
                    <a href="mailto:b7dridi@gmail.com" className="contact-item">
                        <div className="contact-icon">✉️</div>
                        <div><strong>b7dridi@gmail.com</strong><br/><span>Email — best way to reach me</span></div>
                    </a>
                    <a href="tel:+21652983099" className="contact-item">
                        <div className="contact-icon">📞</div>
                        <div><strong>+216 52 98 30 99</strong><br/><span>Phone / WhatsApp</span></div>
                    </a>
                    <a href="https://www.linkedin.com/in/bechir-dev/" target="_blank" rel="noreferrer" className="contact-item">
                        <div className="contact-icon">in</div>
                        <div><strong>linkedin.com/in/bechir-dev</strong><br/><span>LinkedIn</span></div>
                    </a>
                    <a href="https://github.com/Bechir-Dridi" target="_blank" rel="noreferrer" className="contact-item">
                        <div className="contact-icon">⌘</div>
                        <div><strong>github.com/Bechir-Dridi</strong><br/><span>GitHub</span></div>
                    </a>
                    <a href="https://bechirdev.vercel.app" target="_blank" rel="noreferrer" className="contact-item">
                        <div className="contact-icon">🌐</div>
                        <div><strong>bechirdev.vercel.app</strong><br/><span>Portfolio (Vercel)</span></div>
                    </a>
                </div>

                <div className="contact-card">
                    <h3>Quick message</h3>
                    <p style={{color:'#64748b', fontSize:'0.92rem'}}>This form opens your email client — no backend needed.</p>
                    <form onSubmit={(e)=>{
                        e.preventDefault();
                        const fd = new FormData(e.target);
                        const name = fd.get('name'), email = fd.get('email'), msg = fd.get('message');
                        window.location.href = `mailto:b7dridi@gmail.com?subject=Portfolio contact from ${encodeURIComponent(name)}&body=${encodeURIComponent(msg + "\n\nFrom: " + name + " <" + email + ">")}`
                    }} style={{display:'grid', gap:'10px', marginTop:'12px'}}>
                        <input name="name" required placeholder="Your name" style={{padding:'11px 14px', borderRadius:'12px', border:'1px solid #e2e8f0', fontSize:'0.92rem', outline:'none'}} />
                        <input name="email" required type="email" placeholder="Your email" style={{padding:'11px 14px', borderRadius:'12px', border:'1px solid #e2e8f0', fontSize:'0.92rem', outline:'none'}} />
                        <textarea name="message" required placeholder="Tell me about your project, timeline and budget…" rows={5} style={{padding:'11px 14px', borderRadius:'12px', border:'1px solid #e2e8f0', fontSize:'0.92rem', outline:'none', resize:'vertical'}} />
                        <button type="submit" className="btn btn-primary" style={{justifyContent:'center'}}>Send via email →</button>
                        <span style={{fontSize:'0.78rem', color:'#94a3b8', textAlign:'center'}}>Or email directly at b7dridi@gmail.com</span>
                    </form>
                </div>
            </div>

            <div style={{marginTop:'18px', background:'white', border:'1px solid #e2e8f0', borderRadius:'14px', padding:'16px', display:'flex', gap:'14px', flexWrap:'wrap', alignItems:'center', justifyContent:'space-between'}}>
                <div>
                    <strong style={{color:'#0f172a'}}>Remote worldwide</strong>
                    <div style={{color:'#64748b', fontSize:'0.88rem'}}>Working with teams across Europe & MENA. Fluent: AR/EN/FR.</div>
                </div>
                <div style={{display:'flex', gap:'10px'}}>
                    <a href="https://twitter.com/bechir7dridi" target="_blank" rel="noreferrer" className="btn btn-ghost">Twitter</a>
                    <a href="https://www.instagram.com/bdev_7/" target="_blank" rel="noreferrer" className="btn btn-ghost">Instagram</a>
                </div>
            </div>
        </div>
    )
}
